import { PlaceholderSegment } from '@britishcouncil/react-admin';
import { Centered } from 'components';
import { AddRoomButton } from './AddRoomButton';
import { SemanticICONS } from 'semantic-ui-react';
import { useLrwSessionAllowedActions } from 'hooks';

export const NoRoomsSelectedPlaceholder = () => {
  const { canAssignRooms } = useLrwSessionAllowedActions();

  return (
    <Centered>
      <PlaceholderSegment
        icon={'door open' as SemanticICONS}
        color="grey"
        title="No rooms selected"
        description="Please select at least one room to start planning slots"
        data-testid="no-rooms-selected-placeholder"
      >
        {canAssignRooms && <AddRoomButton />}
      </PlaceholderSegment>
    </Centered>
  );
};
